export { default as about } from "./about.json";
export { default as careers } from "./careers.json";
export { default as common } from "./common.json";
export { default as contact } from "./contact.json";
export { default as features } from "./features.json";
export { default as home } from "./home.json";
export { default as legal } from "./legal.json";
export { default as pricing } from "./pricing.json";
